import { useMemo } from 'react';
import Typography from '@mui/material/Typography';

import styles from './alert.module.scss';

type Props = {
  title?: string;
  body: string;
  severity?: 'success' | 'info' | 'warning' | 'error' | 'none';
  icon?: React.ReactNode;
};

const Alert = ({ title, body, severity, icon }: Readonly<Props>): React.JSX.Element => {
  const containerClassName = useMemo(() => {
    switch (severity) {
      case 'success':
        return styles.succes;
      case 'warning':
        return styles.warning;
      case 'error':
        return styles.error;
      case 'none':
        return styles.none;
      default:
        return styles.info;
    }
  }, [severity]);

  return (
    <div className={`${styles.alert} ${containerClassName}`}>
      {icon}
      <div className={styles.bodyContainer}>
        {title && <Typography variant="h5">{title}</Typography>}
        <div className={styles.body}>
          <Typography variant="subtitle1" className={styles.text} sx={{ whiteSpace: 'pre-line' }}>
            {body}
          </Typography>
        </div>
      </div>
    </div>
  );
};
export default Alert;
